import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';


interface ProtectedRouteProps {
  children: ReactNode;
}

const AuthRedirect: React.FC<ProtectedRouteProps> = ({ children }) => {
    const token = localStorage.getItem("authToken");

    if (token) {
        // If not authenticated, redirect to login
        return <Navigate to="/dashboard" replace />;
    }

    // If authenticated, render the child component
    return children;
};

export default AuthRedirect;
